import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StoreEndpointsConstant } from '@constants/store-endpoints.constant';
import { ValidateFields } from '@models/shopping.model';
import { BrandingInfo, LoginInfo, LogoutInfo, UserProfile } from '@models/user-profile.model';
import { TranslationService } from '@services/translation/translation.service';
import { UrlUtils } from '@utils/url.utils';
import { Observable, catchError, map, mergeMap, throwError } from 'rxjs';
import { dataLoaderContext } from 'tangoe-design-system';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  constructor(
    private http: HttpClient,
    private translation_svc: TranslationService,
    private url_svc: UrlUtils
  ) {}

  getUserData(key?: string): Observable<UserProfile> {
    return this.http
      .get<UserProfile>(StoreEndpointsConstant.USER_PROFILE, {
        context: key ? dataLoaderContext(key) : undefined
      })
      .pipe(
        mergeMap((res: UserProfile) =>
          this.translation_svc.getTranslations().pipe(
            catchError((error: HttpErrorResponse) => throwError(() => error)),
            map((translations: [[string, string]]) => {
              this.translation_svc.setTranslations(translations);
              return res;
            })
          )
        )
      );
  }

  getBranding(id: number, key?: string): Observable<BrandingInfo> {
    return this.http.get<BrandingInfo>(
      this.url_svc.parseURL(StoreEndpointsConstant.BRANDING, { id }),
      { context: key ? dataLoaderContext(key) : undefined }
    );
  }

  login(
    email: string,
    client_code: string,
    m_email?: string,
    m_client_code?: string
  ): Observable<LoginInfo> {
    let body: HttpParams = new HttpParams();
    body = body.set('emailAddress', email);
    body = body.set('clientCustomCode', client_code);
    if (m_email) body = body.set('masqueraderEmailAddress', m_email);
    if (m_client_code) body = body.set('masqueraderClientCustomCode', m_client_code);

    return this.http.post<LoginInfo>(StoreEndpointsConstant.LOGIN, body, {
      context: dataLoaderContext('global')
    });
  }

  validateDirectLogin(): Observable<HttpResponse<ValidateFields>> {
    return this.http.post<ValidateFields>(
      StoreEndpointsConstant.VALIDATE_DIRECT_LOGIN,
      '',
      {
        context: dataLoaderContext('global'),
        observe: 'response'
      }
    );
  }

  logout(): Observable<LogoutInfo> {
    return this.http.post<LogoutInfo>(StoreEndpointsConstant.LOGOUT, '');
  }
}
